// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"ad25c415","287":"a7b4e220","781":"e22ea34f","789":"c6217975","839":"2779810c","880":"65902020","984":"ca49d677"}[chunkId] + ".chunk.css";
};